import { useEffect } from 'react';

/**
 * Makes it easy to listen on keyboard click events,
 * when a specific element (ref) is focused.
 *
 * @param ref Reference to an element (useRef instance)
 * @param onKeyPress Callback which should be called when some change happens
 * */
const useKeyPress = (ref, onKeyPress) => {
  useEffect(() => {
    if (!ref || !ref.current) {
      return;
    }

    const elem = ref.current;

    elem.addEventListener('keydown', onKeyPress);

    // eslint-disable-next-line consistent-return
    return () => {
      elem.removeEventListener('keydown', onKeyPress);
    };
  }, [ref, onKeyPress]);
};

export default useKeyPress;
